import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getChildRouterLink} from "root/Wieldy/routePaths";
import {getMessagingMenuTypeForUser, MessagingMenus} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {MessageFilters, MessageMenuTitles} from "root/DataFunctions/Constants";

const ChildMessagingSubmenu = (props ) =>
{
    const globals = useContext(GlobalContext);
    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    // Ensure we always have a default message filter ( From the URL or a default )
    let message_filter_type = queryParams.type === undefined ? MessageFilters.NEW : queryParams.type;

    //Overide if not an editor
    message_filter_type = props.is_editor ? message_filter_type : MessageFilters.SENT;

    //const returnedMessageCount = useRecoilValue(returnedMessageCountAtom);

    const managerMessagingSubmenu = () =>
    {
        return (
            <AppSidebarGroup title='Messages' default={message_filter_type}>
                {<AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'messaging?type=' + MessageFilters.NEW )} title='To Approve' iconName='icon-important' name={MessageFilters.NEW} />}
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'messaging?type=' + MessageFilters.SENT)} title='My Sent' iconName='icon-draft' name={MessageFilters.SENT}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'messaging?type=' + MessageFilters.DRAFT )} title='My Drafts' iconName='icon-edit' name={MessageFilters.DRAFT}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'messaging?type=' + MessageFilters.APPROVED)} title='Approved' iconName='icon-thumb-up' name={MessageFilters.APPROVED} />
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'messaging?type=' + MessageFilters.PENDING)} title='Held Back' iconName='icon-email' name={MessageFilters.PENDING} />
            </AppSidebarGroup>
        )
    }

    const contributorMessagingSubmenu = () =>
    {
        return (
            <AppSidebarGroup title='Messages' default={message_filter_type}>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'messaging?type=' + MessageFilters.SENT)} title={MessageMenuTitles.SENT}  iconName='icon-draft' name={MessageFilters.SENT}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'messaging?type=' + MessageFilters.DRAFT )} title={MessageMenuTitles.DRAFT} iconName='icon-edit' name={MessageFilters.DRAFT}/>
            </AppSidebarGroup>
        )
    }

    const menuSection = () =>
    {
        const menuType = props.is_editor ? managerMessagingSubmenu() : contributorMessagingSubmenu();
        return menuType;
    }

    return (
        <Fragment>
            {menuSection()}
        </Fragment>
    )
}

export default ChildMessagingSubmenu ;